/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from '@jutro/locale';

export default defineMessages({
    dateColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.DATE',
        defaultMessage: 'DATE'
    },
    customerNameColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    productColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policyColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.POLICY #',
        defaultMessage: 'POLICY #'
    },
    initiatorColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.INITIATOR',
        defaultMessage: 'INITIATOR'
    },
    descriptionColumn: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    clickForDetails: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.Click for details',
        defaultMessage: 'Click for details'
    },
    noRecentChangesFound: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.No recent changes found',
        defaultMessage: 'No recent changes found'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.Loading...',
        defaultMessage: 'Loading...'
    },
    viewAllAgentChanges: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.VIEW ALL AGENT CHANGES',
        defaultMessage: 'VIEW ALL AGENT CHANGES'
    },
    viewAllCustomerChanges: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.VIEW ALL CUSTOMER CHANGES',
        defaultMessage: 'VIEW ALL CUSTOMER CHANGES'
    },
    viewAllPolicyChanges: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.VIEW ALL POLICY CHANGES',
        defaultMessage: 'VIEW ALL POLICY CHANGES'
    },
    customerChanges: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.CUSTOMER CHANGES',
        defaultMessage: 'CUSTOMER CHANGES'
    },
    agentChanges: {
        id: 'ml.gateway.views.ActivityReports.MLPolicyChangesReport.Agent CHANGES',
        defaultMessage: 'Agent CHANGES'
    }
});
